import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

export default function DoctorModal(props) {
    if (!props.open) {
        return null;
    }

    return (
        <React.Fragment>
            <div className="Modal">
                <div className="ModalBg">
                    <div className="ModalContent doctors">
                        <header>
                            <h1>Welcome to the Doctor's Office!</h1>
                        </header>
                        <section>
                            <img src={require('../../assets/images/doctors.PNG')} />
                            Dolor excepteur proident id deserunt nisi non ipsum id velit nisi quis irure. Ullamco duis sint duis consectetur amet commodo exercitation. Ad sunt ullamco ea sint. Amet mollit laborum magna dolore labore dolor qui. Aliquip tempor nulla tempor ullamco ipsum qui exercitation officia Lorem dolor. Esse voluptate ex Lorem deserunt velit adipisicing mollit consequat minim cillum eiusmod Lorem occaecat. Quis non excepteur anim aliquip ad velit sunt proident incididunt aliqua deserunt aliqua veniam commodo.

                        </section>
                        <footer>
                            <a href="#" onClick={() => props.onClose()}><CloseIcon style={{ fontSize: 60, color: "black" }} /></a>
                        </footer>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )

}